import { DataConfig } from "@/components/table/useDefaultDataConfig";
import { axiosInstance } from "@/utils/lib/axios";
import { QueryFunctionContext, useQuery } from "@tanstack/react-query";
import { RFSData } from "./rfs";

interface GenerateABDPoleData {
  id: string;
  poleId: string;
  coordinateLat: string;
  coordinateLong: string;
  poleProvider: string;
  poleType: string;
  rfs: RFSData;
  line: string;
  placemarkName: string;
  placemarkCoordinates: string;
}

type GenerateABDFDTsQueryKey = DataConfig & {
  rfsId?: string;
};

async function getGenerateABDPoles(
  queryFunctionContext: QueryFunctionContext,
): Promise<GenerateABDPoleData[]> {
  const { queryKey } = queryFunctionContext;
  const [_, generateABDFDTQueryKey] = queryKey;
  const { rfsId } = generateABDFDTQueryKey as GenerateABDFDTsQueryKey;

  const response = await axiosInstance.get(
    `/api/crud/generate-adb-pole/listWithoutFatFdt/${rfsId ?? ""}`,
  );
  return response.data.data;
}
function useGenerateABDPoles(
  generateABDFDTQueryKey: GenerateABDFDTsQueryKey = {},
  options?: {
    enabled?: boolean;
    staleTime?: number;
  },
) {
  const { rfsId } = generateABDFDTQueryKey;
  return useQuery({
    ...options,
    queryKey: ["getGenerateABDPoles", { rfsId }],
    queryFn: getGenerateABDPoles,
  });
}

export type { GenerateABDPoleData };
export { useGenerateABDPoles };
